<template>
    <section class="navigation" :style="configStyles.primary.text">
        <router-link :to="to">
            {{ config.BRIEF_NEXT }}
        </router-link>
    </section>
</template>
<script>
import { SolutionConsumer } from '../../mixins';

export default {
    name: 'SectionNavigation',
    mixins: [SolutionConsumer],
    props: {
        to: {
            type: [Object, String],
            required: true,
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';

section.navigation {
    text-align: right;
    font-weight: 600;

    > a {
        @include a-reset();
    }
}
</style>
